import React from 'react';
const pains = [{
  emoji: '😰',
  title: 'Constant Session Planning',
  description: 'You spend hours every week trying to create new classes that are safe, engaging, and appropriate for different mobility levels.'
}, {
  emoji: '⚠️',
  title: 'Fear of Doing Too Much... or Too Little',
  description: 'You constantly wonder if an exercise is too difficult, too easy, or not appropriate for the people in front of you.'
}, {
  emoji: '📚',
  title: 'Information Everywhere',
  description: 'You find exercises online, but nothing is organized into a complete coaching system you can actually follow.'
}, {
  emoji: '😩',
  title: 'Mental Exhaustion',
  description: 'Between planning, coaching, motivating participants, and managing classes, you have little time left to focus on what truly matters: helping people age better.'
}];
export function PainSection() {
  return <section className="py-12 px-4 sm:px-6 bg-ivory" data-id="element-130">
      <h2 className="text-3xl sm:text-4xl font-heading font-bold text-center text-petrol mb-3 leading-tight" data-id="element-131">
        DO YOU RECOGNIZE THIS?
      </h2>

      <p className="text-base sm:text-lg text-graphite font-subheading font-semibold text-center mb-10 max-w-2xl mx-auto" data-id="element-132">
        You love helping older adults stay active, but does planning consume
        your entire week?
        <br data-id="element-133" />
        <span className="text-sage font-bold" data-id="element-134">
          If you work with seniors, you probably know one of these situations:
        </span>
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 max-w-4xl mx-auto" data-id="element-135">
        {pains.map((pain, i) => <div key={i} className="bg-cream p-6 rounded-xl border-l-4 border-gold shadow-md flex flex-col gap-4 hover:border-petrol transition-colors" data-id="element-136">
            <div className="text-4xl leading-none" data-id="element-137">{pain.emoji}</div>
            <div data-id="element-138">
              <h3 className="text-lg font-bold text-petrol mb-2 font-body uppercase tracking-wide" data-id="element-139">
                {pain.title}
              </h3>
              <p className="text-graphite text-sm sm:text-base leading-relaxed" data-id="element-140">
                {pain.description}
              </p>
            </div>
          </div>)}
      </div>
    </section>;
}